import {Link} from 'react-router-dom';
import React, { useContext } from 'react';
import {WebContext} from '../webcontext';

export default function Previous() {
  const service = useContext(WebContext);

  return (
    <>
    
      <section className="breadcrumnd-banner">
        <div className="container">
          <div className="breadcrumnd-content text-center">
            <h3 className="text-uppercase fw-500 white-clr mb-xxl-6 mb-xl-5 mb-4">
              Previous
            </h3>
            <ul className="breadcrumnd d-flex justify-content-center align-items-center gap-xxl-3 gap-2">
              <li>
                <Link to={'/'} className="text-uppercase fw-500">Home</Link>
              </li>
              <li>
                <i className="ph ph-caret-right"></i>
              </li>
              <li className="text-uppercase">
                Previous
              </li>
            </ul>
          </div>
        </div>
      </section>

      <main className="main position-relative overflow-hidden" id="mains">

        <section className="hosts-details-section whitebg pt-space pb-space">
          <div className="container">
            <div className="row g-lg-0 g-7 align-items-center justify-content-between">
              <div className="col-lg-6">
                <div className="host-details-thumb tilt w-100 aos-init aos-animate" data-aos="zoom-in" data-aos-duration="1500">
                  <img src="/images/mx-DKMPz7Iy-mixcloud-og-image.jpg" alt="img" className="w-100" />
                <div className="js-tilt-glare" ><div className="js-tilt-glare-inner"></div></div></div>
              </div>
              <div className="col-lg-5">
                <div className="host-details-content">
                  <h3 className="black-clr mb-1">
                    Mixcloud
                  </h3>
                  <span className="theme-clr fz18 fw-500">
                    Previous Shows
                  </span>
                  <ul className="common-social mt-xxl-7 mt-xl-6 mb-5 mb-xxl-7 mb-xl-6 mb-5 d-flex align-items-center gap-2">
                    {service.web?.service.s_mixcloud &&
                      <li>
                        <a href={service.web?.service.s_mixcloud} target="_blank" rel="noreferrer" className="d-center bg4-clr border-0 radius100">
                          <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.8" clip-path="url(#clip0_6308_28)">
                              <path d="M8.72266 9L9.16703 6.10437H6.38859V4.22531C6.38859 3.43313 6.77672 2.66094 8.02109 2.66094H9.28422V0.195625C9.28422 0.195625 8.13797 0 7.04203 0C4.75391 0 3.25828 1.38688 3.25828 3.8975V6.10437H0.714844V9H3.25828V16H6.38859V9H8.72266Z" fill="white"></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_6308_28">
                                <rect width="10" height="16" fill="white"></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </a>
                      </li>
                    }
                  </ul>
                  <h5 className="black-clr fw-500 mb-xxl-10 mb-xl-7 col-ld-6 mb-sm-5 mb-4">
                    Enjoyed or missed a set and can catch the set below
                  </h5>
                  <p className="pra-clr mb-xxl-10 mb-xl-7 col-ld-6 mb-sm-5 mb-4">
                    Keep up to date with our replays on our mixcloud page
                  </p>
                  <p className="pra-clr">
                    {service.web?.service.s_mixcloud}
                  </p>
                </div>
              </div>
            </div>
            <iframe src="https://embed.ultrastream.io/us_eXrAxNAdKzSswjRmj" id="us_eXrAxNAdKzSswjRmj" width="100%" title="Previous Shows"></iframe>
          </div>
        </section>
      </main>
    </>
  )
}
